/*
 * Copyright (c) 2016-2019 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 *
 */

export enum ClrViewportViolation {
  BOTTOM = 0,
  LEFT = 1,
  RIGHT = 2,
  TOP = 3,
}
